import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

// External components
import SubscriptionStatusBadge from "@/components/subscriptionStatusBadge/subscriptionStatusBadge";
import EditDishModal from "@/components/editDishModal/editDishModal";
import ModalCoupon from "@/components/modalCoupon/modalCoupon";

// Helpers
import { localCurrency } from "@/plugins/currency";
import { getMenuPriceByMenuId } from "@/plugins/subscriptions_helper";

@Component({
  components: {
    SubscriptionStatusBadge,
    EditDishModal,
    ModalCoupon,
  },
  methods: {
    getMenuPriceByMenuId,
  },
})
export default class EditSubscriptionDetails extends Vue {
  @Prop({ default: false }) showEditDishModal;

  @Getter getSubscription;
  @Getter getMenuPrices;

  isShowingEditSubcriptionModal = false;
  isShowingCouponModal = false;

  mounted() {
    this.$nextTick(() => {
      this.onShowEditModal();
    });
  }

  @Watch("showEditModal")
  onShowEditModal() {
    if (this.showEditDishModal) {
      this.isShowingEditSubcriptionModal = true;
      this.$emit("cancel-show-edit-dish-modal");
    }
  }

  toLocalCurrency(value) {
    return localCurrency(value);
  }
}
